export default function NotFound() {
const handleGoHome = () => {
    // In a real application, this would use router navigation
    window.location.href = '/';
  };

  return (
    <div className="size-full flex items-center justify-center min-h-screen bg-background">
      <div className="text-center space-y-6 max-w-md mx-auto px-6">
        {/* Large 404 Number */}
        <div className="space-y-2">
          <h1 className="text-9xl font-bold text-muted-foreground/30">
            404
          </h1>
          <h2 className="text-2xl font-medium text-foreground">
            Page Not Found
          </h2>
        </div>
        
        {/* Explanation Text */}
        <div className="space-y-4">
          <p className="text-muted-foreground max-w-sm mx-auto">
            Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or the URL might be incorrect.
          </p>
        </div>
        
        {/* Action Button */}
        <div className="pt-4">
          <button 
            onClick={handleGoHome}
            className="px-8 py-2"
          >
            Go Back Home
          </button>
        </div>
        
        {/* Additional Help */}
        <div className="pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Need help? Check the URL or contact support if the problem persists.
          </p>
        </div>
      </div>
    </div>
  );
}
